import React from 'react';
import SlickCarousel from '../../../../../common/slickCarousel/slickCarousel';
import { ASSESSMENT_QUESTION_TEMPLATE } from '../../../../../common/commonConstant';
import './ProductCarousel.scss';
import { API_STOCK_STATUS, STOCK_STATUS } from '../../../../../services/promotion/utils.service';

const ProductCarousel = ({ typeMapping, data = [], handleAddProductEvent, skinBadge = '' }) => (
  <SlickCarousel slidesToShow={2} slidesToScroll={1} >
    {data.map((product, index) => {
      const isOutOfStock = [API_STOCK_STATUS.OUT_OF_STOCK, STOCK_STATUS.outOfStock, STOCK_STATUS.notYetAvailable]
        .includes(product?.stock?.stockLevelStatus);
      let ProductType;
      if (typeMapping && typeof typeMapping === 'object' && Object.keys(typeMapping).length) {
        ProductType = Object.entries(typeMapping).find(([, productIds]) =>
          productIds.includes(product.id),
        )?.[0];
      }
      return (
        <div
          key={product.title}
          className="products-recommend-card"
          data-slick-index={index}
        >
          <div className="products-recommend-img-container">
            {skinBadge || product.skinBadge ? <img className='skin-badge' src={`/images/skin-assessment/${skinBadge || product.skinBadge}-badge.svg`} /> : null}
            <img src={product.bannerUrl} />
          </div>
          {ProductType && ASSESSMENT_QUESTION_TEMPLATE[ProductType] && (
            <div
              className={`product-card-tag product-card-${ASSESSMENT_QUESTION_TEMPLATE[ProductType].colorName}-tag`}
            >
              <div className="category-general-icon">
                <img
                  src={`/images/assesment/${ASSESSMENT_QUESTION_TEMPLATE[ProductType].icon}.svg`}
                />
              </div>
              <span>{ASSESSMENT_QUESTION_TEMPLATE[ProductType].productTag}</span>
            </div>
          )}
          <div className="products-recommend-card-title">{product.title}</div>
          <div className="products-recommend-price-cart-container">
            <div className="products-recommend-price">
              <span className="products-recommend-price-fix">
                {product.prices[0].currency.symbol}
              </span>
              <span className="products-recommend-price-dynamic">
                {product.prices[0].price}
              </span>
            </div>
            <div className={`products-recommend-cart-container${product?.isSelected ? ' selected' : ''}${isOutOfStock ? ' disabled' : ''}`} onClick={() => !isOutOfStock && handleAddProductEvent(product)}>
              <img
                className="products-recommend-cart__shopping-icon"
                src={product?.isSelected ? "/images/healthAndWellness/assessment/assessment-shop-bag.svg" : "/images/assesment/shopping-bag.svg"}
              />
            </div>
          </div>
          <div className="products-recommend-pvbv">
            <div className="products-recommend-pv">
              <span className="products-recommend-pv-title">PV</span>
              <span className="products-recommend-pv-value">
                {product.amwayValue.pointValue}
              </span>
            </div>
            <div className="products-recommend-bv">
              <span className="products-recommend-pv-title">BV</span>
              <span className="products-recommend-pv-value">
                {product.amwayValue.businessVolume}
              </span>
            </div>
          </div>
        </div>
      );
    })}
  </SlickCarousel>
)

export default ProductCarousel;
